// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';

// Pages
import Home from './pages/Home';
import Equipos from './pages/Equipos';
import Contacto from './pages/Contacto';
import Tienda from './pages/Tienda';
import NotFound from './pages/NotFound';
import NoticiasList from './pages/noticias/NoticiasList';
import NoticiaDetail from './pages/noticias/NoticiaDetail';
import CrearNoticia from './pages/admin/CrearNoticia';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/equipos/*" element={<Equipos />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/tienda" element={<Tienda />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/noticias" element={<NoticiasList />} />
          <Route path="/noticias/tipo/:tipo" element={<NoticiasList />} />
          <Route path="/noticias/:slug" element={<NoticiaDetail />} />
          <Route path="/admin/noticias/43093816" element={<CrearNoticia />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;